import { onMounted, watch } from '@vue/composition-api'
export default function useToggleLayers({ mapRef, layers, visibleLayers }) {
  const toggleLayersVisibility = (newVal, oldVal) => {
    const toShow = newVal.filter(l => !oldVal.includes(l))
    const toHide = oldVal.filter(l => !newVal.includes(l))
    toShow.forEach(l => {
      mapRef.value.map.setLayoutProperty(l, 'visibility', 'visible')
    })
    toHide.forEach(l => {
      mapRef.value.map.setLayoutProperty(l, 'visibility', 'none')
    })
  }
  onMounted(() => {
    const map = mapRef.value.map
    map.on('load', () => {
      layers.value.forEach(layerConfig => {
        const { id, source, layer, before } = layerConfig
        const mapboxLayer = {
          ...layer,
          layout: {
            ...layer.layout,
            visibility: visibleLayers.value.includes(layer.id)
              ? 'visible'
              : 'none'
          }
        }
        map.addSource(id, source)
        map.addLayer(mapboxLayer, before || 'watername_ocean')
      })
    })
  })
  watch(visibleLayers, toggleLayersVisibility)
  return {
    mapRef
  }
}
